export const regenerateMenuStyles = {
  trigger: 'h-8 gap-1',
  iconTrigger: 'h-8 w-8 shrink-0 text-muted-foreground',
  settingsHint: 'max-w-64 cursor-pointer text-xs text-muted-foreground',
  settingsLink: 'font-medium text-primary underline underline-offset-2',
};
